import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-modal-comment',
    templateUrl: './modal-comment.component.html',
    styleUrls: ['./modal-comment.component.scss'],
    standalone: false
})
export class ModalCommentComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ModalCommentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string,

  ) { }

  ngOnInit(): void {
    console.log(this.data)
  }

}
